export const REQUEST_APPROVAL_TYPE = {
  PENDING_APPROVAL: "pending_approval",
  REQUEST: "request",
  WARNING_LETTER: "warning_letter",
  MOVEMENT: "movement",
};

export const REQUEST_APPROVAL_TYPE_LIST = Object.values(REQUEST_APPROVAL_TYPE);

export const REQUEST_APPROVAL_REQUEST_TYPE = {
  LEAVE: "leave",
  OFFSITE_WORK: "offsite_work",
  REDEEM_TIME: "redeem_time",
  ENDORSE_TIME: "endorse_time",
  OVERTIME: "overtime",
  COLLECT_TIME: "collect_time",
};
export const REQUEST_APPROVAL_REQUEST_TYPE_LIST = Object.values(
  REQUEST_APPROVAL_REQUEST_TYPE
);
